export default {
  snackbar: {
    time: 2000,
    color: '',
    visibility: false,
    text: '',
    undo: null
  }
}
